import React, { useRef, useState } from "react";
import { updateData } from "../hooks/update";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./LoginPage.css";
import DarkModeToggler from "../components/shared/DarkModeToggler";

function LoginPage({ toggleDarkMode, darkMode }) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function formSubmitHandler(event) {
    event.preventDefault();
    setLoading(true);
    sessionStorage.clear();
    // verify inputs
    let data = {};
    [...event.target].map((item) => {
      if (item.name) data[item.name] = item.value;
    });
    if (data?.email && data?.password) {
      await updateData("user/login", data, null, true, true, navigate, null);
      setLoading(false);
    }
  }
  // bg-image
  return (
    <>
      {/* main */}
      <div className="fixed bg-transparent w-full flex items-center justify-center flex-col p-8 text-gray-50 z-20">
        {/* toggle dark/light */}
        <div className="fixed right-3 top-3 sm:right-16 sm:top-12">
          <DarkModeToggler toggleDarkMode={toggleDarkMode} />
        </div>
        {/* logo */}
        <div className="p-8 pb-4 w-full h-[6rem] justify-center flex relative z-[-1]">
          <img
            src={"https://i.ibb.co/GkbWBN0/Route-Planner-with-logo.webp"}
            alt="dark logo"
            className={`absolute w-[14rem] ${
              !darkMode
                ? "translate-y-[200%] opacity-0"
                : "translate-y-0 opacity-100"
            } transition-all duration-500`}
          />

          <img
            src={"https://i.ibb.co/wLc0Ggh/Route-Planner-white-1.webp"}
            alt="white logo"
            className={`absolute w-[14rem] ${
              darkMode
                ? "translate-y-[200%] opacity-0"
                : "translate-y-0 opacity-100"
            } transition-all duration-500`}
          />
        </div>

        <div className="max-w-[28rem] px-[1rem] py-[1rem] lg:p-[1.5rem] street-bg shadow-sm border border-gray-500 border-dashed rounded-xl z-[2]">
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          <h1 className="font-poppins text-4xl max-[440px]:text-3xl sm:text-4xl text-center mb-4">
            Sign in
          </h1>
          <form onSubmit={formSubmitHandler}>
            <input
              type="text"
              name="email"
              id="login-email"
              placeholder="Username"
              className="w-full my-2 darkPrimary border border-gray-600 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
              required
            />
            <input
              type="password"
              name="password"
              id="password"
              autoComplete="current-password"
              placeholder="Enter the password"
              className="w-full my-2 darkPrimary border border-gray-600 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
              required
            />
            <button
              disabled={loading}
              className="py-2.5 w-full rounded-md text-center font-semibold text-base border mt-4 lg:mt-4 border-dashed border-gray-600 text-gray-300 hover:text-gray-600 uppercase hover:border-[#D4D4D4] hover:bg-[#D4D4D4] transition-colors duration-150 disabled:bg-gray-400 disabled:hover:border-gray-800 disabled:border-gray-800 disabled:cursor-not-allowed disabled:text-gray-500"
            >
              Sign in
            </button>
          </form>
        </div>
      </div>

      {/* design bg */}
      <div className="country-wrap">
        {/* <div class="mountain-1"></div> */}
        <div class="mountain-2 hidden vxl:block"></div>
        <div className="sun" />
        <div className="moon" />
        <div className="grass" />
        <div className="street">
          <div className="car">
            {/*<div class="car-base"></div>*/}
            <div className="car-body">
              <div className="car-top-back">
                <div className="back-curve" />
              </div>
              <div className="car-gate" />
              <div className="car-top-front">
                <div className="wind-sheild" />
              </div>
              <div className="bonet-front" />
              <div className="stepney" />
            </div>
            <div className="boundary-tyre-cover">
              <div className="boundary-tyre-cover-back-bottom" />
              <div className="boundary-tyre-cover-inner" />
            </div>
            <div className="tyre-cover-front">
              <div className="boundary-tyre-cover-inner-front" />
            </div>
            <div className="base-axcel"></div>
            <div className="front-bumper" />
            <div className="tyre">
              <div className="gap" />
            </div>
            <div className="tyre front">
              <div className="gap" />
            </div>
            <div className="car-shadow" />
          </div>
        </div>
        <div className="street-stripe" />
        <div className="hill">
          {/*<div class="tree-1">
			<div class="branch-1"></div>
			<div class="branch-2"></div>
			<div class="branch-3"></div>
		</div>
		<div class="tree-1">
		<div class="branch"></div>
		<div class="trunk"></div>
	</div>*/}
        </div>
      </div>
    </>
  );
}

export default LoginPage;
